import { useContext } from 'react';

import { EmbedShowcaseContext } from '../context/useEmbedShowcase';

export const useShowcaseEmbed = () => {
  const embedShowcaseData = useContext(EmbedShowcaseContext);
  /**
   * Get query param for embedded showcase
   * @param {string | undefined} prefix - The prefix to use for the query parameters (`&` or `?`).
   * @returns {string}  A string containing the query parameters for `referrer` and `is_embed`.
   */
  const getEmbedQueryParam = (prefix: string | undefined = '&'): string => {
    if (embedShowcaseData?.referrer && embedShowcaseData?.isShowcaseEmbeded) {
      return `${prefix}referrer=${encodeURIComponent(
        embedShowcaseData?.referrer,
      )}${`&is_embed=${embedShowcaseData.isShowcaseEmbeded}`}`;
    }

    return '';
  };

  return {
    getEmbedQueryParam,
  };
};
